const SET_SESSION_DATA = 'session/SET_SESSION_DATA';

export default {
  SET_SESSION_DATA,
};
